export const PORTAL_API = process.env.REACT_APP_CUSTOMER_PORTAL_API;
const STS_AUTHORITY = process.env.REACT_APP_ISSUER_URL;

export const getToken = () =>{
    const sessionKey = `oidc.user:${STS_AUTHORITY}:customer-portal-spa`;
    return JSON.parse(sessionStorage.getItem(sessionKey)!)['access_token'];
}